"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardWithGrid = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const examples_styles_1 = require("../examples-styles");
const components_1 = require("../../components");
const Grid = styled_components_1.default.div.withConfig({ displayName: "reports-Grid", componentId: "reports-axstnn" }) `
  display: grid;
  grid-gap: 8px;
  width: 100%;
`;
const HeaderWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-HeaderWrapper", componentId: "reports-599tkr" }) `
  display: flex;
  flex-flow: row;
`;
const GridBody = (0, styled_components_1.default)(Grid).withConfig({ displayName: "reports-GridBody", componentId: "reports-10v4bxa" }) `
  align-items: flex-end;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
  grid-auto-rows: 1fr;

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 16px;
  }
`;
const Header = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(components_1.CardHeader, Object.assign({}, rest),
        react_1.default.createElement(HeaderWrapper, null, children)));
};
const Body = ({ children }) => react_1.default.createElement(GridBody, null, children);
/**
 * Summary Card
 *
 * @returns ReactElement
 */
const CardWithGrid = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(examples_styles_1.StyledReportCardsContainer, null,
        react_1.default.createElement(base_react_components_1.StandardCard, Object.assign({}, rest),
            react_1.default.createElement(Grid, null, children))));
};
exports.CardWithGrid = CardWithGrid;
exports.CardWithGrid.Header = Header;
exports.CardWithGrid.Body = Body;
exports.default = exports.CardWithGrid;
//# sourceMappingURL=index.js.map